import { RouteRecordRaw } from 'vue-router';

import ErrorView from '@/views/error/ErrorView.vue';

export default function errorRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/error/not-found',
      name: 'error-not-found',
      component: ErrorView,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: () => ({ name: 'error-not-found' }),
    },
  ];
}
